import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Branch } from '@models/lender';
import { InstitutionBranchRepo } from '@repos/institutionBranch/institution-branch.service';
import { take } from 'rxjs/operators';
import { ICON } from '@core/util/icon';
import LogRocket from 'logrocket';
import {
	CreateInstitutionBranchComponent,
	CreateOrUpdateInstitutionModel,
} from '../create-branch/create-branch.component';
import { SnackbarService } from '@services/ui/snackbar.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
	selector: 'app-computershare-branch-select',
	templateUrl: './computershare-branch-select.component.html',
	styleUrls: ['./computershare-branch-select.component.scss'],
	standalone: false,
})
export class ComputershareBranchSelectComponent implements OnInit {
	private computerShareInstitutionId = 'qnMR3Wv';
	public branches: Branch[] = [];
	public loading = true;
	public ICON = ICON;
	public selectedBranch = null;
	public error = false;

	constructor(
		private matDialog: MatDialog,
		private branchRepo: InstitutionBranchRepo,
		private matDialogRef: MatDialogRef<ComputershareBranchSelectComponent>,
		private snackbar: SnackbarService,
	) {
		this.matDialogRef.addPanelClass('computer-share-branch-modal');
	}

	async ngOnInit(): Promise<void> {
		await this.fetchBranches();
	}

	addNew(): void {
		const data: CreateOrUpdateInstitutionModel = {
			showDischargeFields: false,
			institutionId: this.computerShareInstitutionId,
			branchLabel: 'Lender',
			showTransitNumber: false,
			create: true,
		};
		const dialog = this.matDialog.open(CreateInstitutionBranchComponent, {
			data,
		});
		dialog
			.afterClosed()
			.pipe(take(1))
			.subscribe((result) => {
				if (result) {
					this.snackbar.openSnackBar({
						text: 'Lender details submitted for review.',
						type: 'success',
					});
					this.matDialogRef.close(result);
				}
			});
	}

	close(): void {
		this.matDialogRef.close();
	}

	setSelectedBranch(branch: Branch): void {
		this.selectedBranch = branch;
	}

	select(): void {
		this.matDialogRef.close(this.selectedBranch);
	}

	async fetchBranches(): Promise<void> {
		try {
			this.error = false;
			this.branches = (await this.branchRepo
				.All({ financialInstitutionId: this.computerShareInstitutionId })
				.pipe(take(1), untilDestroyed(this))
				.toPromise()) as Branch[];
		} catch (err) {
			this.error = true;
			LogRocket.error('Unable to fetch computershare branches', err);
		} finally {
			this.loading = false;
		}
	}
}
